import React from 'react';

const ContentDe = () => {
  return (
    <>
      <p>
        Ihre Privatsphäre ist uns wichtig. Es ist die Politik der Likiee GmbH, Ihre Privatsphäre zu respektieren und
        alle anwendbaren Gesetze und Vorschriften über persönliche Informationen, die wir möglicherweise über Sie
        sammeln, einzuhalten, einschließlich unserer Website <a href='https://likiee.com'>https://likiee.com</a> und
        anderer Seiten, die wir besitzen und betreiben.
      </p>
      <p>
        Persönliche Informationen sind alle Informationen über Sie, die verwendet werden können, um Sie zu
        identifizieren. Dazu gehören Informationen über Sie als Person (wie Name, Adresse und Geburtsdatum), Ihre
        Geräte, Zahlungsdetails und sogar Informationen darüber, wie Sie eine Website oder einen Online-Dienst nutzen.
      </p>
      <p>
        Im Falle, dass unsere Seite Links zu Websites und Diensten Dritter enthält, beachten Sie bitte, dass diese
        Seiten und Dienste ihre eigenen Datenschutzrichtlinien haben. Nachdem Sie einem Link zu Inhalten Dritter gefolgt
        sind, sollten Sie deren veröffentlichte Datenschutzrichtlinien lesen, um zu erfahren, wie sie persönliche
        Informationen sammeln und verwenden. Diese Datenschutzrichtlinie gilt nicht für Ihre Aktivitäten, nachdem Sie
        unsere Seite verlassen haben.
      </p>
      <p>Diese Richtlinie ist wirksam ab dem 17. November 2023</p>
      <p>Zuletzt aktualisiert: 17. November 2023</p>
      <h3>Informationen, die wir sammeln</h3>
      <p>
        Die von uns gesammelten Informationen fallen in eine von zwei Kategorien: „freiwillig bereitgestellte“
        Informationen und „automatisch gesammelte“ Informationen.
      </p>
      <p>
        „Freiwillig bereitgestellte“ Informationen beziehen sich auf alle Informationen, die Sie uns bewusst und aktiv
        zur Verfügung stellen, wenn Sie unsere Dienste nutzen oder an unseren Werbeaktionen teilnehmen.
      </p>
      <p>
        „Automatisch gesammelte“ Informationen beziehen sich auf alle Informationen, die automatisch von Ihren Geräten
        im Zuge des Zugriffs auf unsere Produkte und Dienstleistungen gesendet werden.
      </p>
      <h3>Protokolldaten</h3>
      <p>
        Wenn Sie unsere Website besuchen, können unsere Server automatisch die Standarddaten protokollieren, die Ihr
        Webbrowser bereitstellt. Dazu können die Internetprotokoll- (IP-) Adresse Ihres Geräts, Ihr Browsertyp und die
        Version, die von Ihnen besuchten Seiten, die Uhrzeit und das Datum Ihres Besuchs, die auf jeder Seite verbrachte
        Zeit und andere Details zu Ihrem Besuch gehören.
      </p>
      <p>
        Außerdem können wir, wenn Sie bestimmte Fehler beim Nutzen der Seite begegnen, automatisch Daten über den Fehler
        und die Umstände seines Auftretens sammeln. Diese Daten können technische Details über Ihr Gerät, was Sie zu tun
        versuchten, als der Fehler auftrat, und andere technische Informationen im Zusammenhang mit dem Problem
        enthalten. Sie erhalten möglicherweise keinen Hinweis auf solche Fehler, selbst im Moment ihres Auftretens, dass
        sie aufgetreten sind oder was die Art des Fehlers ist.
      </p>
      <p>
        Bitte beachten Sie, dass diese Informationen allein möglicherweise nicht persönlich identifizierend sind, es
        jedoch möglich sein kann, sie mit anderen Daten zu kombinieren, um einzelne Personen persönlich zu
        identifizieren.
      </p>
      <h3>Persönliche Informationen</h3>
      <p>
        Wir können nach persönlichen Informationen fragen – zum Beispiel, wenn Sie uns Inhalte einreichen oder uns
        kontaktieren – die eines oder mehrere der Folgenden beinhalten können:
      </p>
      <ul>
        <li>Name</li>
        <li>Email</li>
        <li>Soziale Medien Profile</li>
        <li>Geschlecht</li>
      </ul>
      <h3>Von Benutzern generierte Inhalte</h3>
      <p>
        Wir betrachten „von Benutzern generierte Inhalte“ als Materialien (Text-, Bild- und/oder Videoinhalte), die uns
        von unseren Benutzern zum Zwecke der Veröffentlichung auf unserer Website oder zur erneuten Veröffentlichung auf
        unseren sozialen Medienkanälen freiwillig zur Verfügung gestellt werden. Alle von Benutzern generierten Inhalte
        sind mit dem Konto oder der E-Mail-Adresse verknüpft, die zum Einreichen der Materialien verwendet wird.
      </p>
      <p>
        Bitte beachten Sie, dass alle Inhalte, die Sie zum Zwecke der Veröffentlichung einreichen, nach der
        Veröffentlichung (und nachfolgendem Prüfungs- oder Überprüfungsprozess) öffentlich sein werden. Sobald
        veröffentlicht, können sie für Dritte, die nicht unter diese Datenschutzrichtlinie fallen, zugänglich sein.
      </p>
      <h3>Berechtigte Gründe für die Verarbeitung Ihrer persönlichen Informationen</h3>
      <p>
        Wir sammeln und verwenden Ihre persönlichen Informationen nur, wenn wir einen berechtigten Grund dafür haben. In
        welchem Fall wir nur persönliche Informationen sammeln, die vernünftigerweise notwendig sind, um unsere
        Dienstleistungen für Sie zu erbringen.
      </p>
      <h3>Sammlung und Nutzung von Informationen</h3>
      <p>Wir können persönliche Informationen von Ihnen sammeln, wenn Sie Folgendes auf unserer Website tun:</p>
      <ul>
        <li>Ein Konto registrieren</li>
        <li>Ein mobiles Gerät oder einen Webbrowser verwenden, um auf unseren Inhalt zuzugreifen</li>
        <li>Uns über E-Mail, soziale Medien oder ähnliche Technologien kontaktieren</li>
        <li>Uns auf sozialen Medien erwähnen</li>
      </ul>
      <p>
        Wir können Informationen für die folgenden Zwecke sammeln, halten, nutzen und offenlegen, und persönliche
        Informationen werden nicht in einer Weise weiterverarbeitet, die mit diesen Zwecken unvereinbar ist:
      </p>
      <ul>
        <li>um Ihnen die Kernfunktionen und Dienstleistungen unserer Plattform bereitzustellen</li>
        <li>
          um Ihnen zu ermöglichen, Ihre Erfahrung auf unserer Website zu individualisieren oder zu personalisieren
        </li>
        <li>um mit Ihnen in Kontakt zu treten und zu kommunizieren</li>
        <li>
          um Ihnen den Zugang zu und die Nutzung unserer Website, zugehöriger Anwendungen und zugehöriger sozialer
          Medienplattformen zu ermöglichen
        </li>
        <li>
          für technische Bewertungen, einschließlich des Betriebs und der Verbesserung unserer App, zugehöriger
          Anwendungen und zugehöriger sozialer Medienplattformen
        </li>
      </ul>
      <p>
        Wir können freiwillig bereitgestellte und automatisch gesammelte persönliche Informationen mit allgemeinen
        Informationen oder Forschungsdaten kombinieren, die wir von anderen vertrauenswürdigen Quellen erhalten. Zum
        Beispiel können unsere Marketing- und Marktforschungsaktivitäten Daten und Erkenntnisse ergeben, die wir mit
        Informationen darüber kombinieren, wie Besucher unsere Seite nutzen, um unsere Seite und Ihre Erfahrung darauf
        zu verbessern.
      </p>
      <h4>Sicherheit Ihrer persönlichen Informationen</h4>
      <p>
        Wenn wir persönliche Informationen sammeln und verarbeiten und solange wir diese Informationen aufbewahren,
        werden wir sie mit kommerziell akzeptablen Mitteln schützen, um Verlust und Diebstahl sowie unbefugten Zugriff,
        Offenlegung, Kopieren, Nutzung oder Änderung zu verhindern.
      </p>
      <p>
        Obwohl wir unser Bestes tun werden, um die von Ihnen bereitgestellten persönlichen Informationen zu schützen,
        raten wir, dass keine Methode der elektronischen Übertragung oder Speicherung zu 100% sicher ist und niemand
        absolute Datensicherheit garantieren kann.
      </p>
      <p>
        Sie sind verantwortlich für die Auswahl eines Passworts und dessen allgemeine Sicherheitsstärke, um die
        Sicherheit Ihrer eigenen Informationen im Rahmen unserer Dienste zu gewährleisten. Zum Beispiel, dass alle
        Passwörter im Zusammenhang mit dem Zugriff auf Ihre persönlichen Informationen und Konten sicher und vertraulich
        sind.
      </p>
      <h4>Wie lange wir Ihre persönlichen Informationen aufbewahren</h4>
      <p>
        Wir speichern Ihre persönlichen Informationen nur so lange, wie wir sie benötigen. Dieser Zeitraum kann von dem
        abhängen, wofür wir Ihre Informationen verwenden, gemäß dieser Datenschutzrichtlinie. Zum Beispiel, wenn Sie uns
        persönliche Informationen zur Verfügung gestellt haben, um ein Konto bei uns zu erstellen, können wir diese
        Informationen für die Dauer Ihres Kontos in unserem System aufbewahren. Wenn Ihre persönlichen Informationen für
        diesen Zweck nicht mehr benötigt werden, werden wir sie löschen oder anonymisieren, indem wir alle Details
        entfernen, die Sie identifizieren.
      </p>
      <p>
        Wenn jedoch erforderlich, können wir Ihre persönlichen Informationen zur Erfüllung einer rechtlichen,
        buchhalterischen oder Berichtspflicht oder zu Archivierungszwecken im öffentlichen Interesse, zu
        wissenschaftlichen oder historischen Forschungszwecken oder zu statistischen Zwecken aufbewahren.
      </p>
      <h3>Datenschutz für Kinder</h3>
      <p>
        Wir richten unsere Produkte oder Dienstleistungen nicht direkt an Kinder unter 13 Jahren aus, und wir sammeln
        wissentlich keine persönlichen Informationen über Kinder unter 13 Jahren.
      </p>
      <h3>Weitergabe persönlicher Informationen an Dritte</h3>
      <p>Wir können persönliche Informationen an folgende Personen weitergeben:</p>
      <ul>
        <li>eine Muttergesellschaft, Tochtergesellschaft oder ein Tochterunternehmen unseres Unternehmens</li>
        <li>
          Drittanbieter-Dienstleister, um ihnen die Erbringung ihrer Dienstleistungen zu ermöglichen, einschließlich
          (ohne Einschränkung) IT-Dienstleister, Datenspeicherung, Hosting- und Serveranbieter, Werbenetzwerke,
          Analysetools, Fehlerprotokollierer, Inkassounternehmen, Wartungs- oder Problembehebungsdienstleister,
          Marketing- oder Werbedienstleister, professionelle Berater und Zahlungssystembetreiber
        </li>
        <li>unsere Mitarbeiter, Auftragnehmer und/oder verbundene Unternehmen</li>
        <li>unsere bestehenden oder potenziellen Agenten oder Geschäftspartner</li>
        <li>
          Wirtschaftsauskunfteien, Gerichte, Schiedsgerichte und Aufsichtsbehörden, falls Sie für Waren oder
          Dienstleistungen, die wir Ihnen zur Verfügung gestellt haben, nicht bezahlen
        </li>
        <li>
          Gerichte, Schiedsgerichte, Aufsichtsbehörden und Strafverfolgungsbehörden, wie gesetzlich vorgeschrieben, im
          Zusammenhang mit tatsächlichen oder bevorstehenden rechtlichen Verfahren oder zur Feststellung, Ausübung oder
          Verteidigung unserer rechtlichen Rechte
        </li>
        <li>
          Dritte, einschließlich Agenten oder Subunternehmer, die uns bei der Bereitstellung von Informationen,
          Produkten, Dienstleistungen oder Direktmarketing an Sie unterstützen
        </li>
        <li>Dritte zur Sammlung und Verarbeitung von Daten</li>
        <li>
          eine Einrichtung, die unsere Vermögenswerte und Geschäftsaktivitäten ganz oder weitgehend kauft oder an die
          wir diese übertragen
        </li>
      </ul>
      <p>Die von uns derzeit verwendeten Drittanbieter sind:</p>
      <ul>
        <li>Google Analytics</li>
        <li>Hotjar</li>
        <li>AWS SES</li>
        <li>Google AdSense</li>
        <li>Bing Ads</li>
      </ul>
      <h3>Ihre Rechte und Kontrolle über Ihre persönlichen Informationen</h3>
      <p>
        <strong>Ihre Wahl:</strong> Indem Sie uns persönliche Informationen zur Verfügung stellen, verstehen Sie, dass
        wir Ihre persönlichen Informationen gemäß dieser Datenschutzrichtlinie sammeln, speichern, verwenden und
        offenlegen werden. Sie müssen uns keine persönlichen Informationen zur Verfügung stellen, aber wenn Sie dies
        nicht tun, kann dies Ihre Nutzung unserer Website oder der angebotenen Produkte und Dienstleistungen
        beeinträchtigen.
      </p>
      <p>
        <strong>Informationen von Dritten:</strong> Wenn wir persönliche Informationen über Sie von einem Dritten
        erhalten, werden wir diese gemäß dieser Datenschutzrichtlinie schützen. Wenn Sie Dritten persönliche
        Informationen über jemand anderen zur Verfügung stellen, erklären und garantieren Sie, dass Sie die Zustimmung
        dieser Person zur Bereitstellung der persönlichen Informationen an uns haben.
      </p>
      <p>
        <strong>Marketing-Erlaubnis:</strong> Wenn Sie zuvor zugestimmt haben, dass wir Ihre persönlichen Informationen
        für Direktmarketingzwecke verwenden, können Sie Ihre Meinung jederzeit ändern, indem Sie uns über die unten
        angegebenen Kontaktdaten kontaktieren.
      </p>
      <p>
        <strong>Zugang:</strong> Sie können Details der persönlichen Informationen anfordern, die wir über Sie haben.
      </p>
      <p>
        <strong>Korrektur:</strong> Wenn Sie der Meinung sind, dass die von uns über Sie gespeicherten Informationen
        ungenau, veraltet, unvollständig, irrelevant oder irreführend sind, kontaktieren Sie uns bitte über die in
        dieser Datenschutzrichtlinie angegebenen Kontaktdaten. Wir werden angemessene Schritte unternehmen, um etwaige
        als ungenau, unvollständig, irreführend oder veraltet erkannte Informationen zu korrigieren.
      </p>
      <p>
        <strong>Keine Diskriminierung:</strong> Wir werden Sie nicht diskriminieren, wenn Sie Ihre Rechte in Bezug auf
        Ihre persönlichen Informationen ausüben. Es sei denn, Ihre persönlichen Informationen sind erforderlich, um
        Ihnen eine bestimmte Dienstleistung oder ein Angebot bereitzustellen (z. B. Benutzerunterstützung), werden wir
        Ihnen keine Waren oder Dienstleistungen verweigern und/oder Ihnen unterschiedliche Preise oder Tarife für Waren
        oder Dienstleistungen berechnen, einschließlich der Gewährung von Rabatten oder anderen Vorteilen oder der
        Verhängung von Strafen, oder Ihnen eine andere Ebene oder Qualität von Waren oder Dienstleistungen
        bereitstellen.
      </p>
      <p>
        <strong>Benachrichtigung über Datenverstöße:</strong> Wir werden die für uns geltenden Gesetze in Bezug auf
        Datenverstöße einhalten.
      </p>
      <p>
        <strong>Beschwerden:</strong> Wenn Sie der Meinung sind, dass wir gegen einschlägige Datenschutzgesetze
        verstoßen haben und eine Beschwerde einreichen möchten, kontaktieren Sie uns bitte über die unten angegebenen
        Kontaktdaten und geben Sie uns ausführliche Informationen über den behaupteten Verstoß. Wir werden Ihre
        Beschwerde umgehend untersuchen und Ihnen schriftlich die Ergebnisse unserer Untersuchung und die Schritte, die
        wir zur Bearbeitung Ihrer Beschwerde unternehmen werden, mitteilen. Sie haben auch das Recht, sich in Bezug auf
        Ihre Beschwerde an eine Aufsichtsbehörde oder Datenschutzbehörde zu wenden.
      </p>
      <p>
        <strong>Abbestellen:</strong> Um sich von unserer E-Mail-Datenbank abzumelden oder sich von Kommunikationen
        (einschließlich Marketingkommunikationen) abzumelden, kontaktieren Sie uns bitte über die in dieser
        Datenschutzrichtlinie angegebenen Kontaktdaten oder verwenden Sie die in der Kommunikation bereitgestellten
        Abmeldeeinrichtungen. Möglicherweise müssen wir bestimmte Informationen von Ihnen anfordern, um Ihre Identität
        zu bestätigen.
      </p>
      <h3>Verwendung von Cookies</h3>
      <p>
        Wir verwenden "Cookies", um Informationen über Sie und Ihre Aktivitäten auf unserer Website zu sammeln. Ein
        Cookie ist ein kleines Datenstück, das unsere Website auf Ihrem Computer speichert und bei jedem Besuch abruft,
        damit wir verstehen können, wie Sie unsere Website nutzen. Dies hilft uns, Ihnen Inhalte basierend auf von Ihnen
        angegebenen Präferenzen bereitzustellen.
      </p>
      <p>Weitere Informationen finden Sie in unserer Cookie-Richtlinie.</p>
      <h3>Geschäftsübertragungen</h3>
      <p>
        Wenn wir oder unsere Vermögenswerte erworben werden oder im unwahrscheinlichen Fall, dass wir das Geschäft
        aufgeben oder Insolvenz anmelden, würden wir Daten, einschließlich Ihrer persönlichen Informationen, zu den
        Vermögenswerten zählen, die an Parteien übertragen werden, die uns erwerben. Sie erkennen an, dass solche
        Übertragungen stattfinden können, und dass Parteien, die uns erwerben, Ihre persönlichen Informationen weiterhin
        gemäß dieser Richtlinie verwenden dürfen, die sie als Grundlage für jegliche Rechte oder Nutzungsbefugnisse über
        solche Informationen übernehmen müssen.
      </p>
      <h3>Grenzen unserer Richtlinie</h3>
      <p>
        Unsere Website kann zu externen Websites verlinken, die nicht von uns betrieben werden. Bitte beachten Sie, dass
        wir keine Kontrolle über den Inhalt und die Richtlinien dieser Websites haben und keine Verantwortung oder
        Haftung für ihre jeweiligen Datenschutzpraktiken übernehmen können.
      </p>
      <h3>Änderungen dieser Richtlinie</h3>
      <p>
        Nach eigenem Ermessen können wir unsere Datenschutzrichtlinie ändern, um Aktualisierungen unserer
        Geschäftsprozesse, aktuelle akzeptable Praktiken oder gesetzliche oder behördliche Änderungen widerzuspiegeln.
        Wenn wir uns entscheiden, diese Datenschutzrichtlinie zu ändern, werden wir die Änderungen hier unter demselben
        Link veröffentlichen, über den Sie auf diese Datenschutzrichtlinie zugreifen.
      </p>
      <p>
        Wenn die Änderungen signifikant sind oder wenn dies gesetzlich vorgeschrieben ist, werden wir Sie (basierend auf
        Ihren ausgewählten Kommunikationspräferenzen) und alle unsere registrierten Benutzer über die neuen Details
        informieren und Links zur aktualisierten oder geänderten Richtlinie bereitstellen.
      </p>
      <p>
        Wenn dies gesetzlich vorgeschrieben ist, werden wir Ihre Zustimmung einholen oder Ihnen die Möglichkeit geben,
        sich für neue Verwendungen Ihrer persönlichen Informationen zu entscheiden oder sich dagegen zu entscheiden.
      </p>
      <h3>Zusätzliche Offenlegungen zur Einhaltung der Datenschutz-Grundverordnung (DSGVO) (EU)</h3>
      <h4>Datenverantwortlicher / Auftragsverarbeiter</h4>
      <p>
        Die DSGVO unterscheidet zwischen Organisationen, die personenbezogene Informationen für ihre eigenen Zwecke
        verarbeiten (als "Datenverantwortliche" bekannt) und Organisationen, die personenbezogene Informationen im
        Auftrag anderer Organisationen verarbeiten (als "Auftragsverarbeiter" bekannt). Wir, die Likiee GmbH, mit Sitz
        an der im Abschnitt "Kontakt" angegebenen Adresse, sind ein Datenverantwortlicher in Bezug auf die von Ihnen
        bereitgestellten personenbezogenen Informationen.
      </p>
      <h4>Rechtsgrundlagen für die Verarbeitung Ihrer persönlichen Informationen</h4>
      <p>
        Wir werden Ihre persönlichen Informationen nur dann sammeln und verwenden, wenn wir dazu ein rechtliches Recht
        haben. In diesem Fall werden wir Ihre persönlichen Informationen rechtmäßig, fair und transparent sammeln und
        verwenden. Wenn wir Ihre Zustimmung zur Verarbeitung Ihrer persönlichen Informationen einholen und Sie jünger
        als 16 Jahre sind, werden wir die Zustimmung Ihres Elternteils oder gesetzlichen Vormunds zur Verarbeitung Ihrer
        persönlichen Informationen für diesen speziellen Zweck einholen.
      </p>
      <p>
        Unsere Rechtsgrundlagen hängen von den von Ihnen verwendeten Diensten und Ihrer Nutzung ab. Dies bedeutet, dass
        wir Ihre Informationen nur auf folgenden Grundlagen sammeln und verwenden:
      </p>
      <h3>Ihre Zustimmung</h3>
      <p>
        Wenn Sie uns Ihre Zustimmung zur Sammlung und Verwendung Ihrer persönlichen Informationen für einen bestimmten
        Zweck geben. Sie können Ihre Zustimmung jederzeit über die von uns bereitgestellten Einrichtungen widerrufen.
        Dies hat jedoch keine Auswirkungen auf die Verwendung Ihrer Informationen, die bereits stattgefunden hat. Wenn
        Sie uns kontaktieren, können Sie Ihre Zustimmung zur Verwendung Ihres Namens und Ihrer E-Mail-Adresse erteilen,
        damit wir auf Ihre Anfrage antworten können. Obwohl Sie jederzeit die Löschung Ihrer Kontaktdaten anfordern
        können, können wir keine bereits gesendeten E-Mails zurückrufen. Wenn Sie weitere Fragen zum Widerruf Ihrer
        Zustimmung haben, können Sie sich gerne unter den im Abschnitt "Kontakt" dieser Datenschutzrichtlinie
        angegebenen Kontaktdaten erkundigen.
      </p>
      <h3>Erfüllung eines Vertrags oder einer Transaktion</h3>
      <p>
        Wenn Sie mit uns einen Vertrag oder eine Transaktion abgeschlossen haben oder um vorvertragliche Maßnahmen vor
        dem Abschluss eines Vertrags oder einer Transaktion mit Ihnen zu treffen. Wenn Sie uns beispielsweise mit einer
        Anfrage kontaktieren, benötigen wir möglicherweise persönliche Informationen wie Ihren Namen und Ihre
        Kontaktdaten, um zu antworten.
      </p>
      <h3>Unsere legitimen Interessen</h3>
      <p>
        Wenn wir feststellen, dass es notwendig ist, um unsere legitimen Interessen zu wahren, wie zum Beispiel, um
        unsere Dienste bereitzustellen, zu betreiben, zu verbessern und zu kommunizieren. Wir betrachten unsere
        legitimen Interessen als einschließlich Forschung und Entwicklung, das Verständnis unseres Publikums, Marketing
        und die Förderung unserer Dienstleistungen, Maßnahmen zur effizienten Betreibung unserer Dienste,
        Marketinganalysen und Maßnahmen zum Schutz unserer rechtlichen Rechte und Interessen.
      </p>
      <h3>Einhaltung des Gesetzes</h3>
      <p>
        In einigen Fällen können wir eine rechtliche Verpflichtung haben, Ihre persönlichen Informationen zu verwenden
        oder aufzubewahren. Solche Fälle können (sind jedoch nicht darauf beschränkt) Gerichtsbeschlüsse,
        strafrechtliche Ermittlungen, Anfragen der Regierung und behördliche Verpflichtungen umfassen. Wenn Sie weitere
        Fragen zur Aufbewahrung persönlicher Informationen zur Einhaltung des Gesetzes haben, zögern Sie nicht, die in
        unserem Abschnitt "Kontakt" dieser Datenschutzrichtlinie angegebenen Kontaktdaten zu verwenden.
      </p>
      <h4>Internationale Übertragungen außerhalb des Europäischen Wirtschaftsraums (EWR)</h4>
      <p>
        Wir stellen sicher, dass jegliche Übertragung von persönlichen Informationen aus Ländern des Europäischen
        Wirtschaftsraums (EWR) in Länder außerhalb des EWR durch geeignete Schutzmaßnahmen geschützt wird,
        beispielsweise durch Verwendung von von der Europäischen Kommission genehmigten Standard-Datenschutzklauseln
        oder die Verwendung von verbindlichen Unternehmensregeln oder anderen gesetzlich anerkannten Mitteln.
      </p>
      <h4>Ihre Rechte und Kontrolle Ihrer persönlichen Informationen</h4>
      <p>
        <strong>Einschränken:</strong> Sie haben das Recht zu verlangen, dass wir die Verarbeitung Ihrer persönlichen
        Informationen einschränken, wenn (i) Sie besorgt über die Richtigkeit Ihrer persönlichen Informationen sind;
        (ii) Sie glauben, dass Ihre persönlichen Informationen unrechtmäßig verarbeitet wurden; (iii) Sie möchten, dass
        wir die persönlichen Informationen ausschließlich zum Zwecke eines rechtlichen Anspruchs aufbewahren; oder (iv)
        wir sich mit Ihrer Einwendung im Zusammenhang mit der Verarbeitung auf der Grundlage berechtigter Interessen
        befassen.
      </p>
      <p>
        <strong>Widerspruch gegen die Verarbeitung:</strong> Sie haben das Recht, der Verarbeitung Ihrer persönlichen
        Informationen zu widersprechen, die auf unseren berechtigten Interessen oder dem öffentlichen Interesse beruht.
        Wenn dies geschieht, müssen wir zwingende berechtigte Gründe für die Verarbeitung vorlegen, die Ihre Interessen,
        Rechte und Freiheiten überwiegen, um die Verarbeitung Ihrer persönlichen Informationen fortzusetzen.
      </p>
      <p>
        <strong>Datenübertragbarkeit:</strong> Sie haben möglicherweise das Recht, eine Kopie der persönlichen
        Informationen anzufordern, die wir über Sie halten. Soweit möglich, werden wir diese Informationen im CSV-Format
        oder in einem anderen leicht lesbaren maschinenlesbaren Format bereitstellen. Sie haben möglicherweise auch das
        Recht zu verlangen, dass wir diese persönlichen Informationen an einen Dritten übertragen.
      </p>
      <p>
        <strong>Löschung:</strong> Sie haben möglicherweise das Recht zu verlangen, dass wir die persönlichen
        Informationen, die wir über Sie halten, jederzeit löschen, und wir werden angemessene Schritte unternehmen, um
        Ihre persönlichen Informationen aus unseren aktuellen Aufzeichnungen zu löschen. Wenn Sie uns auffordern, Ihre
        persönlichen Informationen zu löschen, werden wir Ihnen mitteilen, wie sich die Löschung auf Ihre Nutzung
        unserer Website oder unserer Produkte und Dienstleistungen auswirkt. Es kann Ausnahmen von diesem Recht aus
        spezifischen rechtlichen Gründen geben, die wir Ihnen gegebenenfalls in Ihrer Anfrage erläutern werden. Wenn Sie
        Ihr Konto kündigen oder löschen, werden wir Ihre persönlichen Informationen innerhalb von 7 Tagen nach Löschung
        Ihres Kontos löschen. Bitte beachten Sie, dass Suchmaschinen und ähnliche Dritte möglicherweise Kopien Ihrer
        persönlichen Informationen behalten, die mindestens einmal öffentlich gemacht wurden, wie bestimmte
        Profilinformationen und öffentliche Kommentare, selbst nachdem Sie die Informationen von unseren Diensten
        gelöscht oder Ihr Konto deaktiviert haben.
      </p>
      <h3>Kontaktieren Sie uns</h3>
      <p>
        Für Fragen oder Bedenken bezüglich Ihrer Privatsphäre können Sie uns unter folgenden Kontaktdaten erreichen:
      </p>
      <p>
        Pavel Kirakosyan
        <br />
        info@likiee.com
      </p>
    </>
  );
};

export default ContentDe;
